import { useUser } from '../../../config/connection/auth';
import { useVerComo, VerComo } from '../../../stores/verComo';
import { AuthUser, NIVEL, OrigemCompra, Perfil } from '../types';

/** Adm ou dono: veem e fazem tudo. */
export const temPoderDeAdm = (perfil: Perfil | null) => !!perfil && NIVEL[perfil] >= NIVEL.admin;

/** A lista de perfis de uma tela ou item de menu: o dono entra onde o adm entra. */
export const perfilPermitido = (perfis: Perfil[], perfil: Perfil | null) =>
    !!perfil && (perfis.includes(perfil) || (perfil === 'dono' && perfis.includes('admin')));

export interface IPerfilDaConta {
    /** `null` enquanto o /auth/me não respondeu. */
    perfil: Perfil | null;
    origens: OrigemCompra[];
    /** Adm ou dono. */
    ehAdm: boolean;
    /** Confere referências com o fornecedor: comprador e adm. */
    compra: boolean;
    /** Manda para compra e decide: lojista e adm. */
    decide: boolean;
    /** O perfil de verdade da conta, mesmo com "ver como" ligado. */
    perfilReal: Perfil | null;
    /** Cargo que o dono/adm está vendo agora (menu da conta); `null` = o próprio. */
    verComo: VerComo;
}

/** O perfil de quem está logado. A regra de verdade está no back; isto só arruma a tela. */
export function usePerfil(): IPerfilDaConta {
    const auth = useUser();
    const verComoEscolhido = useVerComo(estado => estado.verComo);
    const usuario = (typeof auth.data === 'object' ? auth.data : null) as AuthUser | null;
    const perfilReal: Perfil | null = usuario
        ? usuario.perfil ?? (usuario.role === 'dono' || usuario.role === 'admin' || usuario.role === 'comprador' ? usuario.role : 'lojista')
        : null;
    // "Ver como" só vale para quem é dono/adm de verdade: a tela inteira passa a ser a do cargo escolhido.
    const verComo = temPoderDeAdm(perfilReal) ? verComoEscolhido : null;
    const perfil: Perfil | null = verComo ?? perfilReal;
    return {
        perfil,
        origens: usuario?.origensCompra ?? [],
        ehAdm: temPoderDeAdm(perfil),
        compra: temPoderDeAdm(perfil) || perfil === 'comprador',
        decide: temPoderDeAdm(perfil) || perfil === 'lojista',
        perfilReal,
        verComo,
    };
}
